import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../Services/login.service';

/**
 * Auth Guard to protect routes that require authentication.
 * @param route
 * @param state
 * @returns {boolean} - Returns true if the user is logged in, otherwise redirects to the login page.
 */
export const authGuard: CanActivateFn = (route, state) => {
    const auth = inject(LoginService);
    const router = inject(Router);

    if (auth.isLoggedIn()) {
        return true;
    } else {
        router.navigate(['/login']);
        return false;
    }
};
